var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.48148 0c.25455 0 .46626.18797.51017.43584L28 .53135v6.37624c0 .26085-.18343.4778-.42531.5228l-.0932.00855-2.82151-.0001.016.07421.0055.0777v14.8779c0 .26085-.18342.4778-.42531.52279L24.16297 23H3.83703c-.25455 0-.46626-.18797-.51017-.43584l-.00835-.09551V7.59075a.54365.54365 0 01.0215-.1519l-2.8215.0001c-.25455 0-.46626-.18797-.51017-.43585L0 6.9076V.53134C0 .27049.18343.05354.42531.00855L.51851 0h26.96297zm-11.4074 10.09571h-4.14815l-.0932.00856c-.2419.045-.42532.26194-.42532.5228 0 .29345.23215.53135.51852.53135h4.14814l.0932-.00856c.2419-.045.42532-.26195.42532-.5228 0-.29346-.23215-.53135-.51852-.53135zm10.88888-9.033H1.03704v5.31353h25.92592V1.0627z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFilled);
export default __webpack_public_path__ + "static/media/archive-filled.f2e7cf8f.svg";
export { ForwardRef as ReactComponent };